
// SVG Icon: help
export default { id: "terriajs-help" };
export const id = "terriajs-help";
export const name = "help";
